var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 175C59.3774 175 25.8 141.423 25.8 100C25.8 58.5774 59.3774 25 100.8 25C142.223 25 175.8 58.5774 175.8 100C175.8 141.423 142.223 175 100.8 175Z",
    fill: "url(#paint0_linear_26801_4727)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 110.58C29.8 105.841 33.6414 102 38.38 102H82.71C87.4486 102 91.2899 105.841 91.2899 110.58V139.942C91.2899 144.68 87.4486 148.522 82.71 148.522H66.344C65.5542 148.522 64.914 149.162 64.914 149.952V157.055L56.5927 148.928C56.3255 148.668 55.9669 148.522 55.5936 148.522H38.38C33.6414 148.522 29.8 144.68 29.8 139.942V110.58Z",
    fill: "url(#paint1_linear_26801_4727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5591 127.6C81.5591 128.016 81.4552 128.467 81.2474 128.954C81.0455 129.435 80.7249 129.91 80.2855 130.379C79.8462 130.842 79.2851 131.219 78.6023 131.51C77.9196 131.801 77.124 131.946 76.2156 131.946C75.5269 131.946 74.9005 131.881 74.3365 131.75C73.7724 131.62 73.2589 131.418 72.7958 131.145C72.3386 130.866 71.9171 130.5 71.5311 130.049C71.1868 129.64 70.8929 129.182 70.6495 128.678C70.406 128.167 70.222 127.624 70.0973 127.048C69.9786 126.472 69.9192 125.861 69.9192 125.213C69.9192 124.162 70.0706 123.221 70.3734 122.39C70.6821 121.559 71.1215 120.85 71.6914 120.262C72.2614 119.668 72.9293 119.217 73.6952 118.908C74.4611 118.599 75.2775 118.445 76.1443 118.445C77.2012 118.445 78.1422 118.656 78.9675 119.077C79.7928 119.499 80.4251 120.021 80.8644 120.645C81.3038 121.262 81.5234 121.847 81.5234 122.399C81.5234 122.702 81.4166 122.969 81.2028 123.201C80.9891 123.432 80.7308 123.548 80.428 123.548C80.0896 123.548 79.8343 123.468 79.6621 123.308C79.4959 123.147 79.3089 122.871 79.1011 122.479C78.7567 121.832 78.35 121.348 77.881 121.028C77.4179 120.707 76.8449 120.547 76.1622 120.547C75.0756 120.547 74.2088 120.959 73.5617 121.785C72.9204 122.61 72.5998 123.782 72.5998 125.302C72.5998 126.318 72.7423 127.164 73.0273 127.841C73.3123 128.511 73.716 129.013 74.2385 129.346C74.761 129.678 75.3725 129.844 76.0731 129.844C76.8331 129.844 77.4743 129.657 77.9967 129.283C78.5252 128.903 78.923 128.348 79.1901 127.618C79.3029 127.274 79.4425 126.995 79.6087 126.781C79.7749 126.561 80.0421 126.451 80.4102 126.451C80.7249 126.451 80.995 126.561 81.2206 126.781C81.4463 127 81.5591 127.274 81.5591 127.6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0897 131.724H57.0999C56.524 131.724 56.1113 131.596 55.862 131.341C55.6185 131.079 55.4968 130.667 55.4968 130.103V120.288C55.4968 119.713 55.6215 119.3 55.8709 119.051C56.1262 118.795 56.5358 118.668 57.0999 118.668H61.3301C61.9535 118.668 62.4938 118.706 62.951 118.783C63.4081 118.861 63.8178 119.009 64.18 119.229C64.4887 119.413 64.7618 119.647 64.9993 119.932C65.2368 120.211 65.4179 120.523 65.5426 120.867C65.6672 121.206 65.7296 121.565 65.7296 121.945C65.7296 123.251 65.0765 124.207 63.7703 124.813C65.4862 125.359 66.3441 126.422 66.3441 128.001C66.3441 128.731 66.1571 129.39 65.783 129.978C65.409 130.56 64.9043 130.99 64.269 131.269C63.8712 131.436 63.4141 131.554 62.8975 131.626C62.381 131.691 61.7784 131.724 61.0897 131.724ZM60.8937 125.926H58.1418V129.738H60.9828C62.7699 129.738 63.6634 129.093 63.6634 127.805C63.6634 127.146 63.4319 126.668 62.9688 126.371C62.5057 126.074 61.814 125.926 60.8937 125.926ZM58.1418 120.654V124.029H60.5642C61.2233 124.029 61.7309 123.967 62.0871 123.842C62.4493 123.717 62.7254 123.48 62.9154 123.129C63.0638 122.88 63.138 122.601 63.138 122.292C63.138 121.633 62.9035 121.197 62.4344 120.983C61.9654 120.763 61.25 120.654 60.2881 120.654H58.1418Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.099 130.245L48.4756 128.606H43.1678L42.5444 130.281C42.301 130.934 42.0932 131.376 41.921 131.608C41.7488 131.833 41.4668 131.946 41.0749 131.946C40.7424 131.946 40.4486 131.824 40.1933 131.581C39.938 131.338 39.8103 131.061 39.8103 130.753C39.8103 130.575 39.84 130.391 39.8994 130.201C39.9587 130.011 40.0567 129.746 40.1933 129.408L43.5329 120.93C43.6279 120.686 43.7407 120.395 43.8713 120.057C44.0079 119.713 44.1504 119.428 44.2988 119.202C44.4532 118.976 44.6521 118.795 44.8955 118.659C45.1449 118.516 45.4506 118.445 45.8128 118.445C46.1809 118.445 46.4867 118.516 46.7301 118.659C46.9795 118.795 47.1784 118.973 47.3268 119.193C47.4812 119.413 47.6088 119.65 47.7097 119.905C47.8166 120.155 47.9502 120.49 48.1105 120.912L51.5214 129.337C51.7886 129.978 51.9222 130.444 51.9222 130.735C51.9222 131.038 51.7945 131.317 51.5392 131.572C51.2899 131.821 50.9871 131.946 50.6308 131.946C50.423 131.946 50.2449 131.908 50.0965 131.83C49.9481 131.759 49.8234 131.661 49.7225 131.536C49.6215 131.406 49.5117 131.21 49.3929 130.949C49.2801 130.682 49.1822 130.447 49.099 130.245ZM43.8624 126.62H47.7632L45.795 121.232L43.8624 126.62Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1688 39.0865C76.9998 37.6378 58.8306 37.6378 40.6616 39.0865C37.9488 39.3028 35.7816 41.4486 35.4883 44.1852C33.8936 59.0617 33.8936 73.9383 35.4883 88.8149C35.7817 91.5514 37.9489 93.6972 40.6616 93.9135C58.8306 95.3622 76.9998 95.3622 95.1688 93.9135C97.8814 93.6972 100.049 91.5514 100.342 88.8149C101.937 73.9384 101.937 59.0619 100.342 44.1852C100.049 41.4486 97.8814 39.3028 95.1688 39.0865Z",
    fill: "url(#paint2_linear_26801_4727)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.089 52.8312L101.062 52.8284C78.9643 50.8574 56.8665 50.8574 34.7688 52.8284L34.7417 52.8325C34.9298 49.95 35.1787 47.0689 35.4886 44.1863C35.7822 41.4489 37.9497 39.3028 40.6612 39.0865C58.8311 37.6385 76.9997 37.6385 95.1696 39.0865C97.8811 39.3028 100.049 41.4489 100.342 44.1864C100.652 47.0675 100.901 49.9501 101.089 52.8312Z",
    fill: "url(#paint3_linear_26801_4727)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.854 48.4789C44.6069 48.4789 46.0278 47.0415 46.0278 45.2683C46.0278 43.4952 44.6069 42.0577 42.854 42.0577C41.1011 42.0577 39.6802 43.4952 39.6802 45.2683C39.6802 47.0415 41.1011 48.4789 42.854 48.4789Z",
    fill: "#F87171"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8967 48.4789C63.6496 48.4789 65.0705 47.0415 65.0705 45.2683C65.0705 43.4952 63.6496 42.0577 61.8967 42.0577C60.1439 42.0577 58.7229 43.4952 58.7229 45.2683C58.7229 47.0415 60.1439 48.4789 61.8967 48.4789Z",
    fill: "#A7F3D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3745 48.4789C54.1274 48.4789 55.5483 47.0415 55.5483 45.2683C55.5483 43.4952 54.1274 42.0577 52.3745 42.0577C50.6217 42.0577 49.2007 43.4952 49.2007 45.2683C49.2007 47.0415 50.6217 48.4789 52.3745 48.4789Z",
    fill: "#FBE7A3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1222 84.9554V86.4282C92.1222 87.6299 91.1588 88.6045 89.9695 88.6045H45.8604C44.6711 88.6045 43.7078 87.6299 43.7078 86.4282V84.9554C43.7078 83.7537 44.6711 82.7792 45.8604 82.7792H89.9694C91.1588 82.7792 92.1222 83.7537 92.1222 84.9554Z",
    fill: "#D4D9E2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7402 82.7792V88.6045H45.8604C44.6711 88.6045 43.7078 87.6299 43.7078 86.4282V84.9554C43.7078 83.7537 44.6711 82.7792 45.8604 82.7792H56.7402Z",
    fill: "url(#paint4_linear_26801_4727)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2505 82.7789H58.3475V88.6049H55.2505V82.7789Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3642 65.3121L66.3779 60.0636C64.1111 58.7397 61.2776 60.3946 61.2776 63.0424V73.5391C61.2776 76.1869 64.1111 77.8418 66.3779 76.5179L75.3642 71.2694C77.6309 69.9456 77.6309 66.6359 75.3642 65.3121Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.8 44C110.8 40.6863 113.486 38 116.8 38H166.8C170.114 38 172.8 40.6863 172.8 44V96C172.8 99.3137 170.114 102 166.8 102H116.8C113.486 102 110.8 99.3137 110.8 96V44Z",
    fill: "url(#paint5_linear_26801_4727)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_4727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.8 50.5C117.8 49.6716 118.472 49 119.3 49H146.3C147.128 49 147.8 49.6716 147.8 50.5C147.8 51.3284 147.128 52 146.3 52H119.3C118.472 52 117.8 51.3284 117.8 50.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8 74.5C117.8 73.6716 118.472 73 119.3 73H146.3C147.128 73 147.8 73.6716 147.8 74.5C147.8 75.3284 147.128 76 146.3 76H119.3C118.472 76 117.8 75.3284 117.8 74.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8 66.5C165.8 65.6716 165.128 65 164.3 65H137.3C136.472 65 135.8 65.6716 135.8 66.5C135.8 67.3284 136.472 68 137.3 68H164.3C165.128 68 165.8 67.3284 165.8 66.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8 90.5C165.8 89.6716 165.128 89 164.3 89H137.3C136.472 89 135.8 89.6716 135.8 90.5C135.8 91.3284 136.472 92 137.3 92H164.3C165.128 92 165.8 91.3284 165.8 90.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8 58.5C117.8 57.6716 118.472 57 119.3 57H134.3C135.128 57 135.8 57.6716 135.8 58.5C135.8 59.3284 135.128 60 134.3 60H119.3C118.472 60 117.8 59.3284 117.8 58.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8 82.5C117.8 81.6716 118.472 81 119.3 81H134.3C135.128 81 135.8 81.6716 135.8 82.5C135.8 83.3284 135.128 84 134.3 84H119.3C118.472 84 117.8 83.3284 117.8 82.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8 50.5C150.8 49.6716 151.472 49 152.3 49H164.3C165.128 49 165.8 49.6716 165.8 50.5C165.8 51.3284 165.128 52 164.3 52H152.3C151.472 52 150.8 51.3284 150.8 50.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8 74.5C150.8 73.6716 151.472 73 152.3 73H164.3C165.128 73 165.8 73.6716 165.8 74.5C165.8 75.3284 165.128 76 164.3 76H152.3C151.472 76 150.8 75.3284 150.8 74.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8 66.5C132.8 65.6716 132.128 65 131.3 65H119.3C118.472 65 117.8 65.6716 117.8 66.5C117.8 67.3284 118.472 68 119.3 68H131.3C132.128 68 132.8 67.3284 132.8 66.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8 90.5C132.8 89.6716 132.128 89 131.3 89H119.3C118.472 89 117.8 89.6716 117.8 90.5C117.8 91.3284 118.472 92 119.3 92H131.3C132.128 92 132.8 91.3284 132.8 90.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8 58.5C138.8 57.6716 139.472 57 140.3 57H152.3C153.128 57 153.8 57.6716 153.8 58.5C153.8 59.3284 153.128 60 152.3 60H140.3C139.472 60 138.8 59.3284 138.8 58.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8 82.5C138.8 81.6716 139.472 81 140.3 81H152.3C153.128 81 153.8 81.6716 153.8 82.5C153.8 83.3284 153.128 84 152.3 84H140.3C139.472 84 138.8 83.3284 138.8 82.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8 58.5C156.8 57.6716 157.472 57 158.3 57H164.3C165.128 57 165.8 57.6716 165.8 58.5C165.8 59.3284 165.128 60 164.3 60H158.3C157.472 60 156.8 59.3284 156.8 58.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8 82.5C156.8 81.6716 157.472 81 158.3 81H164.3C165.128 81 165.8 81.6716 165.8 82.5C165.8 83.3284 165.128 84 164.3 84H158.3C157.472 84 156.8 83.3284 156.8 82.5Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.8 113.417C100.8 110.425 103.225 108 106.217 108H160.383C163.375 108 165.8 110.425 165.8 113.417V156.75C165.8 159.741 163.375 162.167 160.383 162.167H106.217C103.225 162.167 100.8 159.741 100.8 156.75V113.417Z",
    fill: "url(#paint6_linear_26801_4727)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.467 129.667C126.455 129.667 129.689 126.433 129.689 122.444C129.689 118.456 126.455 115.222 122.467 115.222C118.478 115.222 115.244 118.456 115.244 122.444C115.244 126.433 118.478 129.667 122.467 129.667Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.173 154.944H153.416C154.592 154.944 155.335 153.76 154.778 152.778L142.276 132.524C141.689 131.628 140.327 131.599 139.677 132.466L130.206 146.278L125.16 140.93C124.541 140.353 123.52 140.353 122.932 140.959L111.935 152.662C111.192 153.616 111.904 154.944 113.173 154.944Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_4727",
    x: 117.8,
    y: 48,
    width: 48,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_4727"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_4727"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_4727",
    result: "effect2_innerShadow_26801_4727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_4727",
    x1: 25.8,
    y1: 36.7188,
    x2: 168.769,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_4727",
    x1: 36.5255,
    y1: 102,
    x2: 103.028,
    y2: 148.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_4727",
    x1: 67.9152,
    y1: 38,
    x2: 67.9152,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_4727",
    x1: 67.9154,
    y1: 38.0005,
    x2: 67.9154,
    y2: 52.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_4727",
    x1: 45.1332,
    y1: 82.7792,
    x2: 52.2394,
    y2: 92.6894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_4727",
    x1: 141.8,
    y1: 38,
    x2: 141.8,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_4727",
    x1: 133.3,
    y1: 108,
    x2: 133.3,
    y2: 162.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCard);
export default __webpack_public_path__ + "static/media/Default-Card.0fc7fa1fd55cc2589818cf370f7d08ab.svg";
export { ForwardRef as ReactComponent };